module.exports = __webpack_public_path__ + "img/vip-banner-bg.975c9d2d.png";